import type { SchoolData } from '@/context/SchoolContext';
import type { TasklistPageJson } from '@/types/tasklistPageJson';
import { parseTasklistPageFromWpPayload } from '@/utils/tasklistPageFromWp';

export type ResolveSecondaryTasklistPageJsonParams = {
  pageId: string;
  schoolData: SchoolData | null;
  signal?: AbortSignal;
};

/**
 * Same precedence as {@link TasklistJsonPage} page load: WP `checklist_secondary_pages[pageId]` →
 * static `/data/pages/{pageId}.json`.
 */
export async function resolveSecondaryTasklistPageJson({
  pageId,
  schoolData,
  signal,
}: ResolveSecondaryTasklistPageJsonParams): Promise<TasklistPageJson | null> {
  const trimmed = pageId?.trim();
  if (!trimmed || !/^[a-zA-Z0-9_-]+$/.test(trimmed)) return null;

  const pages = schoolData?.onboarding_content?.checklist_secondary_pages;
  const wpPayload =
    pages && typeof pages === 'object' ? (pages as Record<string, unknown>)[trimmed] : undefined;

  const fromWp = parseTasklistPageFromWpPayload(wpPayload);
  if (fromWp) return fromWp;

  try {
    const res = await fetch(`/data/pages/${trimmed}.json`, { signal });
    if (!res.ok) return null;
    return (await res.json()) as TasklistPageJson;
  } catch {
    return null;
  }
}
